import { Component, input, output } from '@angular/core';

import { TranslateModule } from '@ngx-translate/core';

import { DocumentsListComponent } from '@camelot/files-basic';
import { FontIconComponent } from '@camelot/icons';
import { LayoutFullPanelComponent, TextComponent, TimeAgoComponent } from '@camelot/ui';
import { ModalState } from '@camelot/utils';

import {
  Communication,
  CommunicationParticipantExtended,
  CommunicationStatus,
  CommunicationType,
} from '../../services/dto/communication';
import { CamTranslationCommunication } from '../../translation.service';
import { CommunicationStatusComponent } from '../communication-status/communication-status.component';
import { CommunicationErrorModal } from '../communication-status/modal/modal.component';
import { ParticipantComponent } from '../participant/participant.component';
import { MessageChatComponent } from './message-chat/message-chat.component';
import { MessageMailComponent } from './message-mail/message-mail.component';
import { MessageSystemComponent } from './message-system/message-system.component';

@Component({
  selector: 'cam-communication-message-container',
  templateUrl: './message-container.component.html',
  styleUrls: ['./message-container.component.scss'],
  imports: [
    CommunicationErrorModal,
    CommunicationStatusComponent,
    DocumentsListComponent,
    FontIconComponent,
    LayoutFullPanelComponent,
    MessageChatComponent,
    MessageMailComponent,
    MessageSystemComponent,
    ParticipantComponent,
    TextComponent,
    TimeAgoComponent,
    TranslateModule,
  ],
})
export class MessageContainerComponent {
  conversationParticipants = input.required<CommunicationParticipantExtended[]>();

  communication = input.required<Communication>();

  taskId = input.required<string>();

  enableReply = input(true);

  askReply = output<{ communication: Communication; isForward: boolean }>();

  readonly CommunicationType = CommunicationType;
  readonly CommunicationStatus = CommunicationStatus;

  public errorModal = new ModalState<string, null>();

  constructor() {
    CamTranslationCommunication.getInstance();
  }

  public open() {
    const communication = this.communication();
    if (communication.id) {
      this.errorModal.asked(communication.id);
    }
  }
}
